import React from 'react';
import StatCard from '../common/StatCard';
import { CreditCard, Users, ShoppingCart, Star, Repeat } from 'lucide-react';

const formatInt = (value) => Number(value || 0).toLocaleString('ru-RU');
const formatMoney = (value) =>
    Number(value || 0).toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

const WebsiteStatsOverview = ({ stats, periodLabel = '30 дн.' }) => {
    return (
        <section aria-label={`Показатели сайта за ${periodLabel}`}>
            <p className="mb-3 text-sm font-medium text-slate-500">Показатели за {periodLabel}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                <StatCard
                    title="Выручка сайта, ₽"
                    value={formatMoney(stats.revenue)}
                    icon={CreditCard}
                    colorClass="bg-indigo-600"
                />
                <StatCard
                    title="Новые пользователи"
                    value={formatInt(stats.users)}
                    icon={Users}
                    colorClass="bg-blue-500"
                />
                <StatCard
                    title="Успешные заказы"
                    value={formatInt(stats.orders)}
                    icon={ShoppingCart}
                    colorClass="bg-purple-500"
                />
                <StatCard
                    title="Выручка Stars, ₽"
                    value={formatMoney(stats.stars_revenue)}
                    icon={Star}
                    colorClass="bg-emerald-600"
                />
                <StatCard
                    title="Уникальные покупатели"
                    value={formatInt(stats.buyers_count)}
                    icon={Repeat}
                    colorClass="bg-amber-500"
                />
            </div>
        </section>
    );
};

export default WebsiteStatsOverview;
